<template>
    <div class="file-zone" @click="clickFileZone">
        <input type="file" id="file-zone-input" :accept="accept.join(', ')" @change="changeFile" hidden>
        <div class="message">
            <span v-if="file"><i class="icon-file-excel mr-2 icon-2x"></i> {{ file.name }}</span>
            <span v-else>Drag & drop or <span class="text-primary">browse</span></span>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        accept : {
            type : Array,
            default() {
                return ['.xlsx'];
            }
        }
    },
    name: "FileInput",
    data() {
        return {
            file: null
        }
    },
    methods : {
        clickFileZone()
        {
            document.getElementById('file-zone-input').click();
        },
        changeFile(element)
        {
            this.file = element.target.files[0];

            this.$emit('change', this.file);
        }
    }
}
</script>

<style scoped>
    .file-zone{
        border: 2px dashed #009688;
        height: 100px;
        background-color: #e0f2f1;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }
    .message{
        margin-top: 38px;
        color: #777777;
    }

    .message > span > i{
        font-size: 24px;
    }
</style>
